/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  getDealLimitByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
        },
        required: ['compositeKey'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
